module.exports = __webpack_public_path__ + "static/media/photo-3.a5c9df46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/willow-walk-extension/photo-3.jpg
// module id = 169
// module chunks = 0